var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseToLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C9A8C4A-948E-4C3A-BA63-9CA4BA94CD8B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-View",
    stroke: "none",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pluses",
    transform: "translate(-26.000000, -55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Plus",
    transform: "translate(19.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0769231,12.0769231 L7,12.0769231 L7,12.9230769 L12.0769231,12.9230769 L12.0769231,18 L12.9230769,18 L12.9230769,12.9230769 L18,12.9230769 L18,12.0769231 L12.9230769,12.0769231 L12.9230769,7 L12.0769231,7 L12.0769231,12.0769231 Z",
    id: "Combined-Shape",
    fill: "#B3B3B3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseToLogin);
export default __webpack_public_path__ + "static/media/close-to-login.e2a8b126096b3164db0b6b973b8a7e90.svg";
export { ForwardRef as ReactComponent };